export default __webpack_public_path__ + "static/Major-Expenses-Remote-Workers-Setting-up-1eb1ef0e24450f64d31b32381c640a12.jpg";